export default __webpack_public_path__ + "static/media/plus.adc7cacb.svg";